import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Page } from '../../../common/hooks/useCurrentPage';
import {
  selectCategories,
  selectCurrentArticle,
  selectCurrentCategory,
} from '../../../common/selectors/helpCenter';
import { selectSolutions } from '../../../common/selectors/solutions';
import { noop } from '../../../util';
import { biHelpCenter } from '../../../util/bi';
import { assertUnreachable } from '../../../util/guards';

export const useBackButtonBiTracker = (currentPage: Page): (() => void) => {
  const currentCategory = useSelector(selectCurrentCategory);
  const categories = useSelector(selectCategories);
  const article = useSelector(selectCurrentArticle);
  const solutions = useSelector(selectSolutions);

  return useCallback(() => {
    switch (currentPage) {
      case Page.Article:
        return article && biHelpCenter.logBackButtonOnArticleView(article.id);
      case Page.Categories:
        return (
          categories && biHelpCenter.logCategoriesListBackClicked(categories)
        );
      case Page.Category:
        if (!currentCategory) {
          return;
        }

        if (currentCategory.children?.length) {
          return biHelpCenter.logCategorySubCategoryListBackClicked(
            currentCategory,
          );
        } else {
          return biHelpCenter.logCategorySolutionListBackClicked(
            currentCategory,
          );
        }
      case Page.Chatbot:
        return biHelpCenter.logBackButtonOnChatbotView();
      case Page.Search:
        return (
          solutions && biHelpCenter.logBackButtonOnArticlesListView(solutions)
        );
      case Page.Home:
        // Back button BI event for Home page is not supported(this button is not shown for Home page)
        return noop();
      default:
        assertUnreachable(currentPage);
    }
  }, [currentPage, categories, article, currentCategory, solutions]);
};
